import React, {Component, PureComponent} from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper/index'
import {TableComp} from 'sz-react-utils'
// import GetAllFormFields from '../../../components/_utils/formUtils'
import {Button, Card, Form,Row,Col, Tooltip, DatePicker, Select, Drawer, notification} from 'antd'
import _ from 'lodash'
import Request, {API_URL} from '../../request'
import {connect} from 'react-redux'
import {FormUtils as GetAllFormFields} from 'sz-react-utils'
import moment from 'moment'
import { RightsWrapper } from '../../components/_utils/utils'
import ViewUserAttendence from '../../components/_utils/viewUserAttendence'
import UpdateSalaryStatus from '../../components/_utils/updateSalaryStatus'



const {MonthPicker} = DatePicker
const Option = Select.Option;
@Form.create()
class UserSalary extends PureComponent {
    state = {
        count: 0,
        defaultPageSize: 20,
        month:null,
        record:{},
        showAttendenceDrawer:false,
        showSalaryApproveDrawer:false,
        recordId:'',
        uanDeduction:0
    }

    handleSalaryAction = (salaryId) =>{
        this.setState({showSalaryApproveDrawer:true, recordId:salaryId})
    }

    viewAttendence = (data)=> {
        this.setState({showAttendenceDrawer:true, record:data})
    }

    refreshFxn = () => {
        this.setState({refreshChild: !this.state.refreshChild})
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
    }

    apiRequest = params =>{
        return new Promise(async(resolve)=>{
            if(this.state.month) {
                params.attendanceYearMonth = moment(this.state.month).format('YYYY-MM')
            }
            params.deleted = false
            let response = await Request.getUserPayroll(params)
            console.log(response);
            this.setState({count:response.total})
            resolve(response)
        })
    }

    handleMonthChange = (month,dateString) =>{
        if(month === null) {
            this.setState({month:null})
            this.reload()
        }else {
            this.setState({month:moment(month)}, ()=>{
                this.reload()
            })
        }
    }

    async componentDidMount() {

    }

    onClose = () =>{
        this.setState({showSalaryApproveDrawer:false, recordId:'', record:{}, showAttendenceDrawer:false})
        this.reload()
    }

    reload = () => {    
        this.table.current.reload();
    };

    render() {
        const {defaultPageSize, showSalaryApproveDrawer, showAttendenceDrawer, count, record} = this.state
        const columns = [
            {
                title:'Month',
                key:'attendanceYearMonth'
            },
            {
                title: 'Total Worked Hours',
                key: 'totalHours',
                render:(text,record)=>(
                    record && record.totalTimeWorked?record.totalTimeWorked:record.totalHours
                )
            },
            {
                title: 'Extra Hours',
                key: 'extraHours',
            },
            {
                title: 'Leave Hours / Days',
                key: 'hourDeduction',
                render:(text,record) =>(
                    <div>
                        <span>{record.hourDeduction}/{record.hourDeduction/record.allowedWorkingHours}</span>
                    </div>
                )
                
            },
            {
                title: 'Total Hours / Days',
                key: 'totalWorkedHours',
                render:(text,record) => (
                    <div>
                        <span>{record.totalWorkedHours.toFixed(2)}/{(record.totalWorkedHours/record.allowedWorkingHours).toFixed(1)}</span>
                    </div>
                )
            },
            // {
            //     title: 'Salary (Before EPF Deductions)',
            //     key: 'totalSalary',
            //     width:150,
            //     render:(text,record)=>(
            //         <span>{text.toFixed(2)}</span>
            //     )
            // },
            // {
            //     title: 'EPF',
            //     key: 'epf',
            //     render:(text,record)=>(
            //         <div>
            //             {record.epf>0?record.epf:0}
            //         </div>
            //     )
            // },
            // {
            //     title: 'ESIC',
            //     key: 'esic',
            //     render:(text,record)=>(
            //         <div>
            //             {record.esic>0?record.esic:0}
            //         </div>
            //     )
            // },
            {
                title:'Previous Adjustment',
                key:'previousAdjustment'
            },
            // {
            //     title: 'UAN Deduction',
            //     key: 'uanDeduction',
            //     render:(text,record)=>{
            //         if(record.uanNumber && record.staffSalary > 21000 || record.uanNumber && record.staffSalary > 15000 && record.staffSalary <= 21000) {
            //             this.setState({uanDeduction:record.totalSalary*25/100})
            //             return (
            //                 record.totalSalary*25/100
            //             )
            //         }
            //     }
            // },
            // {
            //     title: 'Take Home Salary',
            //     key: 'inHandSalary',
            //     render:(text,record)=>{
            //         if(!record.uanNumber) {
            //             return (
            //                 <div>{(record.totalSalary - record.epf - record.esic).toFixed(2)}</div>
            //             )
            //         }else if (record.uanNumber && record.staffSalary > 21000) {
            //             return (
            //                 <div>{(record.totalSalary - (record.totalSalary*25/100)).toFixed(2)}</div>
            //             )
            //         }
            //     }
            // },
            // {
            //     title: 'Take Home Salary',
            //     key: 'totalAfterDeduction',
            // },
            {
                title:'Status',
                key:'confirmationStatus'
            },
            {
                title:'Action',
                key:'operation',
                dataindex: "operation",
                render: (text, record) => (
                    <div>
                    {record.confirmationStatus === "Approved"?
                    null:
                    <Tooltip title="Action">
                        <Button
                        size={"small"}
                        shape="circle"
                        onClick={()=>this.handleSalaryAction(record._id)}
                        icon="forward"
                        />
                    </Tooltip>
                    }
                    <Tooltip title="View Attendence">
                        <Button size={"small"}
                        shape="circle"
                        onClick={()=>{this.viewAttendence(record)}}
                        icon='eye' />
                    </Tooltip>
                    </div>
                ),
            }
        ]


    return (
        <PageHeaderWrapper title={`Salaries:- ${count}` }>
            {
                showSalaryApproveDrawer?
                <UpdateSalaryStatus onClose={this.onClose} recordId={this.state.recordId} />
                :null
            }
            {
                showAttendenceDrawer?
                <ViewUserAttendence onClose={this.onClose} record={record} />
                :null
            }
            <Card bordered={true}>
                <Row>
                    <Col span={4}>
                        <MonthPicker placeholder='Select Month' format="YYYY-MM" onChange={this.handleMonthChange} />
                    </Col>
                </Row>
            </Card>
            <Card bordered={true} >
                <TableComp
                    ref={this.table}
                    columns={columns}
                    apiRequest={this.apiRequest}
                    // extraProps={{scroll: {x: 1450}}}
                    pagination={{
                        showSizeChanger: true,
                        defaultPageSize: defaultPageSize,
                        pageSizeOptions: ['10', '20', '50', '100', '1000']
                    }}
                />
            </Card>
        </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({global, router}) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search,
    pathname: router.location.pathname
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserSalary)
